export function PrivacyPolicyPage() {
  return (
    <main className="legal-page">
      <section className="legal-hero">
        <div className="section-eyebrow">Privacy Policy</div>
        <h1>Zion Classical Academy Mobile App</h1>
        <p className="muted">Effective date: May 20, 2026</p>
      </section>

      <section className="legal-section">
        <h2>Overview</h2>
        <p>
          Zion Classical Academy provides this mobile app and related admin web tools to help families,
          teachers, and staff communicate about school activities, announcements, calendars, volunteer
          information, and account access. This Privacy Policy explains how information is collected,
          used, and protected when approved users access the app.
        </p>
      </section>

      <section className="legal-section">
        <h2>Information We Collect</h2>
        <p>We collect information needed to operate school communication and account features, including:</p>
        <ul>
          <li>Account information such as name, email address, role, and authentication status.</li>
          <li>School roster information connected to students, families, parents, teachers, and staff.</li>
          <li>Messages, announcements, volunteer entries, and related school communication content.</li>
          <li>Notification preferences and device push notification tokens when users enable notifications.</li>
          <li>Basic technical information used for security, troubleshooting, auditing, and service operation.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>How We Use Information</h2>
        <p>Information is used to:</p>
        <ul>
          <li>Provide secure account access for approved Zion Classical Academy users.</li>
          <li>Deliver school messages, announcements, calendar information, and notifications.</li>
          <li>Support volunteer reporting and other school operations.</li>
          <li>Maintain app security, audit administrative activity, and troubleshoot technical issues.</li>
          <li>Send account activation, notification, and school-related email messages.</li>
        </ul>
      </section>

      <section className="legal-section">
        <h2>Notifications And Email</h2>
        <p>
          Users may receive push notifications for school communication. Users may also choose to receive
          email copies of certain notifications when available. Account setup and activation emails may be
          sent to the email address associated with a user's school account. Notification preferences can be
          managed in the app where available.
        </p>
      </section>

      <section className="legal-section">
        <h2>Information Sharing</h2>
        <p>
          We do not sell personal information. Information is used for school purposes and may be shared
          only with authorized school personnel, approved service providers that help operate the app, or
          as required by law. Service providers may include cloud hosting, authentication, database,
          notification, and transactional email providers.
        </p>
      </section>

      <section className="legal-section">
        <h2>Data Security</h2>
        <p>
          The app uses authentication, role-based access controls, and cloud security rules to help protect
          school information. No system can guarantee absolute security, but we take reasonable steps to
          limit access to authorized users and protect information used by the app.
        </p>
      </section>

      <section className="legal-section">
        <h2>Children's Privacy</h2>
        <p>
          The app is intended for use by Zion Classical Academy families, teachers, and staff. Student
          information is used for school communication and administrative purposes. The app is not intended
          as a public service for children to create independent accounts without school authorization.
        </p>
      </section>

      <section className="legal-section">
        <h2>Data Retention</h2>
        <p>
          School records, messages, volunteer entries, audit logs, and related app data may be retained as
          needed for school operations, legal obligations, security, and recordkeeping. Data may be updated
          or removed according to school administrative processes.
        </p>
      </section>

      <section className="legal-section">
        <h2>Your Choices</h2>
        <p>
          Users can manage available notification preferences in the app. To request help with account
          access, correction of account information, or privacy questions, contact Zion Classical Academy.
        </p>
      </section>

      <section className="legal-section">
        <h2>Contact</h2>
        <p>
          For privacy questions about the Zion Classical Academy app, contact the school office.
        </p>
        <p>
          <strong>Zion Classical Academy</strong>
          <br />
          Email: <a href="mailto:office@zionclassical.org">office@zionclassical.org</a>
          <br />
          Website: <a href="https://zionclassical.org">https://zionclassical.org</a>
        </p>
      </section>

      <section className="legal-section">
        <h2>Changes To This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Updated versions will be posted on this page
          with a revised effective date.
        </p>
      </section>
    </main>
  );
}
